/**
 * arrayValidator.js
 * Talkroute
 *
 * Created by Vel Genov on 2/21/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Validates that the passed in variable is an array with length larger than 0
 *
 * @param arrayToValidate the array to validate
 * @returns true if this is an array with length larger than 0. False otherwise
 */
const validateArray = (arrayToValidate) => {
  if (Array.isArray(arrayToValidate) && arrayToValidate.length > 0) {
    return true;
  }

  return false;
};

export default validateArray;
